// src/pages/admin/Settings.jsx
import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  Switch,
  FormControlLabel,
  Slider,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import { motion } from "framer-motion";

export default function SettingsPage() {
  const [darkMode, setDarkMode] = useState(true);
  const [notifications, setNotifications] = useState(true);
  const [limit, setLimit] = useState(5000);
  const [currency, setCurrency] = useState("USD");

  const handleSave = () => {
    window.dispatchEvent(
      new CustomEvent("showSnackbar", {
        detail: { message: "Settings saved successfully!", severity: "success" },
      })
    );
  };

  return (
    <Box>
      {/* Header */}
      <Typography variant="h5" sx={{ color: "#0ff", fontWeight: "bold", mb: 3 }}>
        Settings
      </Typography>

      {/* Form Card */}
      <Card
        sx={{
          bgcolor: "rgba(25,25,50,0.7)",
          border: "1px solid #0ff4",
          borderRadius: 3,
          backdropFilter: "blur(12px)",
          p: 3,
          mb: 4,
        }}
      >
        <FormControlLabel
          control={
            <Switch
              checked={darkMode}
              onChange={() => setDarkMode(!darkMode)}
              color="info"
            />
          }
          label="Dark Mode"
        />
        <FormControlLabel
          control={
            <Switch
              checked={notifications}
              onChange={() => setNotifications(!notifications)}
              color="success"
            />
          }
          label="Enable Notifications"
        />

        <Box sx={{ mt: 3 }}>
          <Typography gutterBottom>Transaction Limit: ${limit.toLocaleString()}</Typography>
          <Slider
            value={limit}
            onChange={(e, val) => setLimit(val)}
            min={100}
            max={10000}
            step={100}
            sx={{ color: "#0ff" }}
          />
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography gutterBottom>Default Currency</Typography>
          <Select
            value={currency}
            onChange={(e) => setCurrency(e.target.value)}
            sx={{ bgcolor: "rgba(25,25,50,0.9)", color: "#fff", borderRadius: 2 }}
          >
            <MenuItem value="USD">USD - US Dollar</MenuItem>
            <MenuItem value="EUR">EUR - Euro</MenuItem>
            <MenuItem value="NGN">NGN - Nigerian Naira</MenuItem>
          </Select>
        </Box>

        <Button
          variant="contained"
          sx={{
            mt: 4,
            bgcolor: "#0ff",
            color: "#000",
            fontWeight: "bold",
            boxShadow: "0 0 15px cyan",
            "&:hover": {
              bgcolor: "#0cc",
              boxShadow: "0 0 25px cyan",
            },
          }}
          onClick={handleSave}
        >
          Save Settings
        </Button>
      </Card>

      {/* Live Preview */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4 }}
      >
        <Card
          sx={{
            bgcolor: darkMode ? "rgba(15,15,30,0.9)" : "rgba(245,245,255,0.9)",
            color: darkMode ? "#0ff" : "#000",
            border: "1px solid #0ff4",
            borderRadius: 3,
            p: 3,
          }}
        >
          <Typography variant="h6">Live Preview</Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Theme: {darkMode ? "Dark" : "Light"}  
          </Typography>
          <Typography variant="body2">
            Notifications: {notifications ? "Enabled" : "Disabled"}  
          </Typography>
          <Typography variant="body2">
            Transaction Limit: ${limit.toLocaleString()}  
          </Typography>
          <Typography variant="body2">Currency: {currency}</Typography>
        </Card>
      </motion.div>
    </Box>
  );
}